import Box from '@mui/material/Box';
import { Element } from 'react-scroll';
import ChatBubble from './ChatBubble';
import CircularProgress from '@mui/material/CircularProgress';
import { useContext, useEffect } from 'react';
import { MessageContext } from '../../context/MessageContext';
import { scroller } from 'react-scroll';
import { Link, Typography } from '@mui/material';

interface GeminiPanelProps {}

const GeminiPanel = (props: GeminiPanelProps) => {
  const { geminiChat, isGeminiLoading } = useContext(MessageContext);

  useEffect(() => {
    if (geminiChat.length > 0) {
      scroller.scrollTo('last-user-gemini-message', {
        duration: 500,
        delay: 100,
        smooth: true,
        containerId: 'gemini-chatbox',
      });
    }
  }, [geminiChat]);

  return (
    <>
      <Typography
        sx={{
          backgroundColor: '#fff59d',
          paddingTop: '2px',
          marginTop: '4px',
          paddingX: '4px',
          borderTopLeftRadius: '4px',
          borderTopRightRadius: '4px',
        }}
      >
        We asked your question to a public LLM (Google Gemini) to provide you
        with an additional source of information. This answer is for reference
        only and may or may not be helpful directly or through the references
        provided.
      </Typography>
      <Box
        id="gemini-chatbox"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 2,
          mb: 2,
          flexGrow: 1,
          height: '35vh',
          overflowY: 'auto',
        }}
      >
        {geminiChat.length === 0 && (
          <ChatBubble
            message={'Please ask a question in the main chat'}
            isUser={false}
          />
        )}
        {geminiChat.map((message, index) => {
          const createMessageName = (): string => {
            if (message.isUser) {
              if (
                index === geminiChat.length - 1 ||
                index === geminiChat.length - 2
              ) {
                return 'last-user-gemini-message';
              }
            }
            return 'other-message';
          };

          return (
            <Box
              key={index}
              sx={{
                width: '100%',
                minHeight: 'auto',
                paddingRight: '20px',
              }}
            >
              <Element name={createMessageName()}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <ChatBubble message={message.text} isUser={message.isUser} />
                </Box>
              </Element>
            </Box>
          );
        })}
        {isGeminiLoading && (
          <Box sx={{ marginBottom: '100vh' }}>
            <ChatBubble
              message={
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <CircularProgress />
                  <Box marginLeft={'5px'}>Checking Gemini</Box>
                </Box>
              }
              isUser={false}
            />
          </Box>
        )}
      </Box>
      {geminiChat.length > 0 && (
        <>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Citations
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: '20px',
              mt: 1,
            }}
          >
            {geminiChat[geminiChat.length - 1].citations?.map(
              (citation, index) => (
                <Link
                  key={index}
                  href={citation.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ textDecoration: 'none', color: 'primary.main' }}
                >
                  {citation.name}
                </Link>
              )
            )}
          </Box>
        </>
      )}
    </>
  );
};
export default GeminiPanel;
